<template>
    <router-link :class="product.class" :to="product.href">
        <div class="box">
            <div class="box--overlay"></div>
            <img :src="product.thumbnail"/>
            <h3>{{ product.titles.fr.join(' / ') }}<br/><span>{{ product.titles.en.join(' / ') }}</span></h3>
        </div>
    </router-link>
</template>

<script>

    export default {
        name: "ProductBox",
        props: {
            product: {
                required: true,
                type: Object
            }
        }
    }
</script>

<style lang="scss" scoped>
    a :hover {
        .box {
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.23);
        }
    }
</style>